import {
  type GetProductCatalogError,
  useGetProductCatalog,
} from '@/generated/http-clients/v3ApiComponents'
import type { Products } from '@/generated/http-clients/v3ApiSchemas'
import type { UseQueryResult } from '@tanstack/react-query'
import type React from 'react'
import { createContext, useContext } from 'react'

const ProductCatalogContext = createContext<
  UseQueryResult<Products, GetProductCatalogError> | undefined
>(undefined)

export const ProductCatalogProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const productCatalog = useGetProductCatalog(
    {},
    {
      staleTime: 5 * 60 * 1000, // 5 minutes
      // Cache data between route changes to avoid unnecessary refetches
      gcTime: 10 * 60 * 1000, // 10 minutes cache time
      // Disable automatic refetching to prevent unnecessary API calls
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    },
  )

  return (
    <ProductCatalogContext.Provider value={productCatalog}>
      {children}
    </ProductCatalogContext.Provider>
  )
}

export const useProductCatalog = () => {
  const context = useContext(ProductCatalogContext)
  if (!context) {
    throw new Error(
      'useProductCatalog must be used within a ProductCatalogProvider',
    )
  }
  return context
}
